/* eslint-disable consistent-return */
/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@material-ui/core'
import { ColorBox } from 'material-ui-color'
import { mdiCheck, mdiClose, mdiEyeClosed, mdiEyeOutline } from '@mdi/js'
import Icon from '@mdi/react'
import React, { useEffect, useState } from 'react'
import { ValidatorForm } from 'react-material-ui-form-validator'
import { useSelector } from 'react-redux'

import colors from '../../../../assets/colors'
import BaseCreatePage from '../../../../components/hooks/BaseCreatePage'
import { CustomSwitch } from '../../../../components/ui/custom-switch'
import { usePermissions } from '../../../../hooks/usePermission'
import { cpfMask } from '../../../../util/utils'
import AutoComplete from '../../../components/Autocomplete'
import SelectField from '../../../components/SelectField'
import CustomTextField from '../../../components/Textfield'

const INITIAL_FIELDS = {
  id: '',
  name: '',
  email: '',
  role_id: [],
  cpf: '',
  password: '',
  confirmPassword: '',
  showConfirmPassowrd: false,
  showPassword: false,
  company_id: '',
  laundries: [],
  laundryClients: '',
  laundryClient_id: {},
  resend: false,
  color: '#93c3ea',
  status: 1,
  error: false,
  can_see_service_values: true,
  can_see_service_client_phone: true,
  laundry_id: '',
}

const UserForm = ({ data, see, onSubmit }) => {
  const roles = useSelector(state => state.user.roles || [])
  const laundries = useSelector(state => state.user.laundries || [])
  const laundryClients = useSelector(state => state.user.laundryClients)
  const userRoles = useSelector(state => state.auth.role || [])
  const permissionUser = useSelector(state => state.auth.permissionUser || [])

  const { hasPermission } = usePermissions()

  const [fields, setFields] = useState(INITIAL_FIELDS)

  useEffect(() => {
    if (!data?.id) return

    setFields(prev => ({
      ...prev,
      ...data,
      laundryClients: data.laundryClient_id,
    }))
  }, [data])

  const updateFields = (name, value) => {
    if (name === 'laundryClient_id') {
      return setFields(prev => ({
        ...prev,
        laundryClients: value,
        [name]: value,
      }))
    }

    setFields(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  const onChange = name => event => {
    const { value } = event.target
    setFields(prev => ({
      ...prev,
      [name]: name === 'cpf' ? cpfMask(value) : value,
    }))
  }

  const handleToggle = name => () => {
    setFields(prev => ({
      ...prev,
      [name]: !prev[name],
    }))
  }

  const showConfirmPassowrd = () =>
    updateFields('showConfirmPassowrd', !fields.showConfirmPassowrd)

  const showPassword = () => updateFields('showPassword', !fields.showPassword)

  const hanldeError = () => updateFields('error', !fields.error)

  const updateFunction = (areas, array) => {
    setFields(prev => ({
      ...prev,
      [array]: areas.sort((a, b) => a.name.localeCompare(b.name)),
    }))
  }

  const hasRole = (stringRole = 'administrador') =>
    userRoles.some(role => role.name == stringRole)

  const roleHasID = array => {
    const item = fields.role_id?.find(role =>
      array.find(arrayItem =>
        role.sys_name?.toLowerCase().includes(arrayItem.toLowerCase())
      )
    )

    return !!item
  }

  const handleSubmit = () => {
    const invalidRole =
      roleHasID(['atendente_parceiro_lavanderia']) && fields.role_id?.length > 1

    if (invalidRole) return

    const send = {
      ...fields,
      laundry_id: fields.laundry_id?.id || '',
      status: fields.status || 0,
    }

    onSubmit && onSubmit(send)
  }

  const handleConfirmPassword = e => {
    e.preventDefault()

    const { value } = e.target

    if (!fields.password) return

    if (!value && fields.error) return hanldeError()

    if (fields.confirmPassword != fields.password) return hanldeError()

    if (fields.confirmPassword == fields.password && fields.error)
      return hanldeError()
  }

  const {
    laundryClient_id,
    role_id,
    email,
    name,
    cpf,
    password,
    confirmPassword,
    showPassword: showPasswordValue,
    showConfirmPassowrd: showConfirmPassowrdValue,
    error,
    color,
    id,
    resend,
    status,
    can_see_service_values,
    can_see_service_client_phone,
    laundry_id,
  } = fields

  const readOnly = !!see

  return (
    <ValidatorForm onSubmit={handleSubmit} style={{ width: '100%' }}>
      <Grid
        container
        spacing={2}
        style={{ marginTop: '1em' }}
        justifyContent="space-between"
      >
        <Grid item md={4} sm={12} xs={12}>
          <Grid
            item
            xs={12}
            container
            alignItems="flex-start"
            justifyContent="center"
          >
            <Grid
              item
              xs={12}
              style={{
                fontSize: '14px',
                color: colors.gray,
                padding: '8px',
              }}
            >
              Selecione uma cor para o usuário
            </Grid>

            <ColorBox
              value={color}
              disableAlpha
              style={{ width: '100%' }}
              hideTextfield
              onChange={newColor =>
                setFields(prev => ({
                  ...prev,
                  color: `#${newColor.hex}`,
                }))
              }
            />
          </Grid>
        </Grid>

        <Grid item md={8} sm={12} xs={12}>
          <Grid container style={{ marginTop: '1em' }} spacing={2}>
            <Grid item xs={6}>
              <CustomTextField
                validators={['required', 'minStringLength:3']}
                errorMessages={[
                  'Campo Obrigatório',
                  'Tamanho Mínimo de 3 caracteres',
                ]}
                onChange={onChange('name')}
                label="Nome"
                fullWidth
                value={name}
                disabled={readOnly}
              />
            </Grid>

            <Grid item xs={12} lg={6} sm={12} md={6}>
              <CustomTextField
                validators={['isEmail']}
                errorMessages={['O campo não representa um email válido']}
                onChange={onChange('email')}
                required
                label="E-mail"
                fullWidth
                value={email}
                disabled={readOnly}
              />
            </Grid>

            <Grid item xs={12} lg={6} sm={12} md={6}>
              <CustomTextField
                value={cpf}
                onChange={onChange('cpf')}
                disabled={readOnly}
                validators={[
                  'matchRegexp:^([0-9]{2}[.]?[0-9]{3}[.]?[0-9]{3}[/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9]{2})$',
                ]}
                errorMessages={['CPF/CNPJ Inválido']}
                label="CPF/CNPJ"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} lg={6} sm={12} md={6}>
              <TextField
                onChange={onChange('password')}
                label="Senha"
                type={showPasswordValue ? 'text' : 'password'}
                fullWidth
                value={password}
                disabled={readOnly}
                autoComplete="current-password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" onClick={showPassword}>
                      <IconButton>
                        {showPasswordValue ? (
                          <Icon path={mdiEyeOutline} size={1} />
                        ) : (
                          <Icon path={mdiEyeClosed} size={1} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} lg={6} sm={12} md={6}>
              <TextField
                onChange={onChange('confirmPassword')}
                label="Confirmar senha"
                required={password || false}
                value={confirmPassword}
                onBlur={handleConfirmPassword}
                fullWidth
                type={showConfirmPassowrdValue ? 'text' : 'password'}
                disabled={readOnly}
                error={error}
                helperText={error ? 'As senhas não coincidem' : ''}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      onClick={showConfirmPassowrd}
                    >
                      <IconButton>
                        {showConfirmPassowrdValue ? (
                          <Icon path={mdiEyeOutline} size={1} />
                        ) : (
                          <Icon path={mdiEyeClosed} size={1} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {!roleHasID(['afiliado']) && hasRole('administrador') && (
              <Grid item xs={12} lg={6} sm={6} md={6}>
                <SelectField
                  options={laundryClients}
                  data={laundryClient_id}
                  label="Cliente Lavanderia"
                  setForm={updateFields}
                  name="laundryClient_id"
                />
              </Grid>
            )}

            <Grid item xs={12}>
              {role_id && (
                <AutoComplete
                  options={roles}
                  label="Tipo de Usuário"
                  data={role_id}
                  updateFunction={updateFunction}
                  limitTags={8}
                  name="role_id"
                  readOnly={readOnly}
                  error={
                    roleHasID(['atendente_parceiro_lavanderia']) &&
                    role_id?.length > 1
                  }
                  helperText={
                    roleHasID(['atendente_parceiro_lavanderia']) &&
                    role_id?.length > 1
                      ? 'O tipo de usuário Atendente Parceiro Lavanderia é único'
                      : ''
                  }
                />
              )}
            </Grid>

            {roleHasID(['atendente_parceiro_lavanderia']) &&
              hasPermission('create-modulo-parceiros', permissionUser) && (
                <Grid item xs={12}>
                  <SelectField
                    options={laundries}
                    data={laundry_id}
                    label="Parceiro"
                    setForm={updateFields}
                    name="laundry_id"
                    disabled={readOnly}
                  />
                </Grid>
              )}

            <Grid
              item
              container
              xs={12}
              sm={6}
              alignItems="flex-end"
              justifyContent="flex-start"
              style={{ color: colors.gray }}
            >
              {id && email && (
                <Grid item xs={12} container alignItems="center">
                  <FormControlLabel
                    control={
                      <Checkbox
                        fullWidth
                        disabled={readOnly}
                        checked={Boolean(resend)}
                        onChange={handleToggle('resend')}
                        value={resend}
                      />
                    }
                    label="Reenviar email de cadastro"
                  />
                </Grid>
              )}
            </Grid>

            <Grid
              item
              xs={12}
              sm={
                roleHasID(['gerente_lavanderia']) && hasRole('administrador')
                  ? 3
                  : 6
              }
              container
              justifyContent={
                roleHasID(['gerente_lavanderia']) && hasRole('administrador')
                  ? 'flex-start'
                  : 'flex-end'
              }
              alignItems="center"
            >
              <CustomSwitch
                checked={status}
                onChange={handleToggle('status')}
                disabled={readOnly}
              />
              Ativar usuário
            </Grid>
          </Grid>

          {roleHasID(['operador_de_rua_lavanderia']) &&
            hasRole('gerente_lavanderia') && (
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <BaseCreatePage
                      page="Configurações App"
                      path="Operador de Rua"
                      hiddenReturn
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Grid container alignItems="center" spacing={1}>
                      <Grid item>
                        <Button
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            gap: '4px',
                            padding: '4px 8px',
                            fontWeight: 'normal',
                            textTransform: 'none',
                            color: colors.grayMedium,
                            border: `1px solid ${colors.graylight}`,
                            borderRadius: '16px',
                          }}
                          onClick={handleToggle('can_see_service_values')}
                          disabled={readOnly}
                        >
                          <Typography>Operador vê valor da OS</Typography>

                          <Box
                            style={{
                              borderRadius: '50%',
                              height: '24px',
                              marginLeft: '4px',
                              width: '24px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundColor: can_see_service_values
                                ? colors.bgSucess
                                : colors.bgError,
                              color: can_see_service_values
                                ? colors.sucess
                                : colors.error,
                            }}
                          >
                            <Icon
                              path={
                                can_see_service_values ? mdiCheck : mdiClose
                              }
                              size={0.7}
                            />
                          </Box>
                        </Button>
                      </Grid>

                      <Grid item>
                        <Button
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            gap: '4px',
                            alignItems: 'center',
                            padding: '4px 8px',
                            fontWeight: 'normal',
                            textTransform: 'none',
                            color: colors.grayMedium,
                            border: `1px solid ${colors.graylight}`,
                            borderRadius: '16px',
                          }}
                          onClick={handleToggle('can_see_service_client_phone')}
                          disabled={readOnly}
                        >
                          <Typography>
                            Operador vê telefone do cliente da OS
                          </Typography>

                          <Box
                            style={{
                              borderRadius: '50%',
                              height: '24px',
                              marginLeft: '4px',
                              width: '24px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundColor: can_see_service_client_phone
                                ? colors.bgSucess
                                : colors.bgError,
                              color: can_see_service_client_phone
                                ? colors.sucess
                                : colors.error,
                            }}
                          >
                            <Icon
                              path={
                                can_see_service_client_phone
                                  ? mdiCheck
                                  : mdiClose
                              }
                              size={0.7}
                            />
                          </Box>
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}
        </Grid>

        {!readOnly && (
          <Grid
            item
            container
            xs={12}
            style={{
              paddingTop: '2em',
              marginTop: '2em',
            }}
            justifyContent="center"
            alignItems="center"
          >
            <Button
              type="submit"
              style={{
                width: '101px',
                height: '30px',
                backgroundColor: colors.primary,
                color: '#FFF',
                fontSize: '14px',
                borderRadius: '15px',
                textTransform: 'capitalize',
                '&:hover': {
                  opactity: 0.8,
                  backgroundColor: 'inherit',
                },
              }}
            >
              Salvar
            </Button>
          </Grid>
        )}
      </Grid>
    </ValidatorForm>
  )
}

export default UserForm
